import React from "react";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import moment from "moment";
import Pagination from "../../components/pagination/pagination";
import _ from "lodash";

const Tab = props => {
  let today = new Date();
  let {
    active,
    start,
    data,
    classes,
    header_tab_data,
    tableHeaderColor,
    changePage
  } = props;

  if (data.length <= 0) return <div></div>;

  if (active === "history") {
    return (
      <div className={classes.tableResponsive}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>CallBit Vehicle ID</TableCell>
              <TableCell>1</TableCell>
              <TableCell>2</TableCell>
              <TableCell>3</TableCell>
              <TableCell>4</TableCell>
              <TableCell>5</TableCell>
              <TableCell>6</TableCell>
              <TableCell>7</TableCell>
              <TableCell>8</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(vehicle => {
              let inspections =
                vehicle.inspections !== undefined && vehicle.inspections.items;
              if (header_tab_data === "dot") {
                inspections =
                  vehicle.inspections !== undefined &&
                  inspections.filter(item => {
                    return item.inspectionType === "DOT_ANNUAL_INSPECTION";
                  });
              } else {
                inspections =
                  vehicle.inspections !== undefined &&
                  inspections.filter(item => {
                    return item.inspectionType !== "DOT_ANNUAL_INSPECTION";
                  });
              }
              inspections =
                vehicle.inspections !== undefined &&
                inspections.sort((a, b) => {
                  return (
                    moment(b.nextInspectionDue) - moment(a.nextInspectionDue)
                  );
                });
              if (inspections <= 0) return null;
              return (
                <TableRow>
                  <TableCell>{vehicle.customerVehicleId}</TableCell>
                  {inspections.slice(0, 8).map(inspection => {
                    return (
                      <React.Fragment>
                        <TableCell style={{ padding: 0 }}>
                          {inspection.nextInspectionDue}
                        </TableCell>
                      </React.Fragment>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
  let inspections = [];
  data.map(vehicle => {
    if (vehicle.inspections !== undefined) {
      vehicle.inspections.items.map(inspection => {
        inspections.push(inspection);
      });
    }
  });
  inspections =
    active === "due"
      ? inspections.filter(item => {
          return new Date(item.nextInspectionDue) < today;
        })
      : inspections.filter(item => {
          return new Date(item.nextInspectionDue) >= today;
        });
  if (header_tab_data === "dot") {
    inspections = inspections.filter(item => {
      return item.inspectionType === "DOT_ANNUAL_INSPECTION";
    });
  } else {
    inspections = inspections.filter(item => {
      return item.inspectionType !== "DOT_ANNUAL_INSPECTION";
    });
  }
  inspections = inspections.sort((a, b) => {
    return moment(b.nextInspectionDue) - moment(a.nextInspectionDue);
  });
  return (
    <React.Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} style={{ minHeight: 580 }}>
          <div className={classes.tableResponsive}>
            <Table className={classes.table}>
              <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
                <TableRow>
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                  >
                    Vehicle ID
                  </TableCell>

                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                  >
                    Due Date
                  </TableCell>
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                  >
                    Due Next
                  </TableCell>
                  <TableCell
                    className={classes.tableCell + " " + classes.tableHeadCell}
                  >
                    Due Last
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map(vehicle => {
                  let inspections =
                    active === "due"
                      ? vehicle.inspections !== undefined &&
                        vehicle.inspections.items.filter(item => {
                          return (
                            item.nextInspectionDue !== undefined &&
                            new Date(item.nextInspectionDue) < today
                          );
                        })
                      : vehicle.inspections !== undefined &&
                        vehicle.inspections.items.filter(item => {
                          return (
                            item.nextInspectionDue !== undefined &&
                            new Date(item.nextInspectionDue) >= today
                          );
                        });

                  if (header_tab_data === "dot") {
                    inspections =
                      vehicle.inspections !== undefined &&
                      inspections.filter(item => {
                        return item.inspectionType === "DOT_ANNUAL_INSPECTION";
                      });
                  } else {
                    inspections =
                      vehicle.inspections !== undefined &&
                      inspections.filter(item => {
                        return item.inspectionType !== "DOT_ANNUAL_INSPECTION";
                      });
                  }
                  inspections =
                    vehicle.inspections !== undefined &&
                    inspections.sort((a, b) => {
                      return (
                        moment(b.nextInspectionDue) -
                        moment(a.nextInspectionDue)
                      );
                    });

                  let { length } = inspections;

                  let inspection = inspections[length - 1];
                  if (inspection === undefined) return null;
                  let previous = inspections[length - 2];
                  let due_next;
                  let dateClasses = "";
                  if (new Date(inspection.nextInspectionDue) < today) {
                    dateClasses = "";
                  } else if (
                    new Date(inspection.nextInspectionDue) > today &&
                    moment(inspection.nextInspectionDue) <
                      moment(today).add(7, "days")
                  ) {
                    dateClasses = "bg-red";
                  } else if (
                    moment(inspection.nextInspectionDue) >
                      moment(today).add(7, "days") &&
                    moment(inspection.nextInspectionDue) <
                      moment(today).add(15, "days")
                  ) {
                    dateClasses = "bg-yellow";
                  } else if (
                    moment(inspection.nextInspectionDue) >
                      moment(today).add(15, "days") &&
                    moment(inspection.nextInspectionDue) <
                      moment(today).add(30, "days")
                  ) {
                    dateClasses = "bg-lightgreen";
                  } else if (
                    moment(inspection.nextInspectionDue) >
                    moment(today).add(30, "days")
                  ) {
                    dateClasses = "bg-lightgreen";
                  }
                  if (inspection.inspectionType === "DOT_ANNUAL_INSPECTION") {
                    due_next = moment(inspection.nextInspectionDue).add(
                      1,
                      "years"
                    )._d;
                  } else if (
                    inspection.inspectionType === "BIT_90DAY_INSPECTION"
                  ) {
                    due_next = moment(inspection.nextInspectionDue).add(
                      90,
                      "days"
                    )._d;
                  } else if (
                    inspection.inspectionType === "BIT_45DAY_INSPECTION"
                  ) {
                    due_next = moment(inspection.nextInspectionDue).add(
                      45,
                      "days"
                    )._d;
                  }
                  return (
                    <TableRow>
                      <TableCell>{vehicle.customerVehicleId}</TableCell>
                      <TableCell className={dateClasses}>
                        {inspection.nextInspectionDue}
                      </TableCell>
                      <TableCell>{`${new Date(
                        due_next
                      ).getFullYear()}-${new Date(due_next).getMonth() +
                        1}-${new Date(due_next).getDate()}`}</TableCell>
                      <TableCell>
                        {previous !== undefined && previous.nextInspectionDue}
                      </TableCell>
                      <TableCell>
                        <span
                          onClick={() =>
                            props.history.push(
                              `/inspection/details/${inspection.id}`
                            )
                          }
                          className="fancy-a"
                        >
                          <a href="#">Details</a>
                        </span>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </GridItem>
      </GridContainer>
      {data.length > 10 && (
        <div style={{ marginTop: 20 }}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Pagination onPageSelect={changePage} start={start} data={data} />
            </GridItem>
          </GridContainer>
        </div>
      )}
    </React.Fragment>
  );
};

export default Tab;



// WEBPACK FOOTER //
// ./src/admin/adminDashboard/tab.jsx